import ApplyForm from "../Components/ApplyForm";
import FAQs from "../Components/FAQs";
import Week from "../Components/Week";

export default function Syllabus() {
  const syllabusData = [
    {
      text: "Introduction to Embedded Systems",
      subDescription: [
        "Overview, Applications, and Architecture",
        "Role of Microcontrollers and Microprocessors",
        "Embedded Development Workflow",
      ],
    },
    {
      text: "Programming Basics for Embedded Systems",
      subDescription: [
        "C/C++ Programming Fundamentals",
        "Embedded C Concepts and Optimizations",
        "Debugging and Testing Code",
      ],
    },
    {
      text: "Microcontroller Programming",
      subDescription: [
        "Architecture and Peripherals (e.g., Arduino, ESP32, Raspberry Pi & STM32)",
        "GPIO, Timers, and PWM",
        "Memory Management",
      ],
    },
    {
      text: "Real-Time Operating Systems (RTOS)",
      subDescription: [
        "Concepts of Multitasking and Scheduling",
        "Task Synchronization and Communication",
        "Implementing RTOS on Microcontrollers",
      ],
    },
    {
      text: "Communication Protocols",
      subDescription: [
        "UART, I2C, and SPI",
        "CAN and LIN Protocols",
        "Wireless Communication (e.g., Bluetooth, ZigBee)",
      ],
    },
    {
      text: "Sensors and Actuators",
      subDescription: [
        "Interfacing Analog and Digital Sensors",
        "Controlling Motors (DC, Servo, Stepper)",
        "Signal Conditioning and ADC/DAC",
      ],
    },
    {
      text: "Power Management and Optimization",
      subDescription: [
        "Low-Power Modes and Energy Efficiency",
        "Power Supply Design Basics",
      ],
    },
    {
      text: "Embedded Security",
      subDescription: [
        "Secure Bootloaders and Firmware Updates",
        "Cryptography Basics for Embedded Systems",
      ],
    },
    {
      text: "IoT and Connectivity",
      subDescription: [
        "Basics of IoT Architectures",
        "Integrating Wi-Fi and MQTT Protocols",
        "Cloud Connectivity for Embedded Devices",
      ],
    },
    {
      text: "Project Design and Development",
      subDescription: [
        "End-to-End Development of an Embedded System Project",
        "Prototyping and Testing",
        "Deployment and Documentation",
      ],
    },
  ];
  const syllabusData_one = [
    {
      title: "Week 1: Fundamentals of Embedded Systems",
      note: "Writing simple C programs and simulating them in an IDE.",
      description: [
        {
          text: "Introduction to Embedded Systems",
          subDescription: ["Definition, Applications, and Architecture"],
        },
        "Microcontrollers vs. Microprocessors",
        "Overview of Embedded Software Development",
        {
          text: "Basics of C Programming for Embedded Systems",
          subDescription: ["Data Types, Control Structures, and Functions"],
        },
        {
          text: "Setting Up Development Environment",
          subDescription: ["IDEs, Compilers, and Debuggers"],
        },
      ],
    },
    {
      title: "Week 2: Microcontroller Basics",
      note: "Controlling LEDs and switches using GPIO.",
      description: [
        "Introduction to Microcontrollers (e.g., Arduino &amp; ESP32)",
        {
          text: "GPIO Basics and Peripheral Interfacing",
          subDescription: ["LEDs, Switches, and Keypads"],
        },
        {
          text: "Memory and Registers",
          subDescription: ["Flash, SRAM, and EEPROM"],
        },
        "Interrupts and Polling",
      ],
    },
    {
      title: "Week 3: Real-Time Systems",
      note: "Develop a timer-based LED blinking application.",
      description: [
        "Task Scheduling and Multi-threading Basics",
        "Understanding Timers and Counters",
        "Handling Interrupts and ISRs (Interrupt Service Routines)",
      ],
    },
    {
      title: "Week 4: Communication Protocols",
      note: "Interfacing sensors and devices using UART and I2C protocols.",
      description: [
        {
          text: "Overview of Communication Protocols",
          subDescription: ["UART, I2C, SPI"],
        },
        "Serial Communication with Microcontrollers",
        "Introduction to CAN and LIN Protocols",
        "Debugging Communication Interfaces",
      ],
    },
    {
      title: "Week 5: Advanced Embedded Software Design Patterns",
      note: "Create a mini project involving multiple communication protocols and real-time processing.",
      description: [
        {
          text: "Embedded Software Design Patterns",
          subDescription: ["State Machines and Event-Driven Programming"],
        },
        "Power Management in Embedded Systems",
        "Introduction to Embedded Security",
      ],
    },
    {
      title: "Final Week: Project and Deployment",
      noteLabel: "Capstone Project :",
      note: "Develop a complete embedded application, such as a temperature monitoring system or an IoT-enabled device.",
      description: [
        "Project Planning and Development",
        "Code Optimization and Debugging Techniques",
        "Testing and Validation of Embedded Systems",
        "Deployment Strategies",
      ],
    },
  ];
  return (
    <>
    <style jsx>{`
  .syllabus_heading {
    text-align: center;
    font-size: 3rem;
    margin-bottom: 2rem;
    color: #004085;
  }

  .card_container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    padding: 1rem;
  }

  .card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  .card_title {
    font-size: 1.5rem;
    color: #006a4f;
    margin-bottom: 1rem;
  }

  .card_sublist {
    list-style-type: circle;
    padding-left: 20px;
    margin: 0;
    color: #001f3f;
    font-weight: 600;
  }

  .card_subitem {
    margin-bottom: 0.5rem;
  }

  /* Media Query for max-width 768px */
  @media (max-width: 768px) {
    .card_container {
      grid-template-columns: 1fr;
    }
  }


`}</style>


    <div className="container-xxl py-5">
  <div className="container-fluid  d-flex align-items-center justify-content-center">
    <div className="row g-5">
      <div
        className="col-lg-6 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ minHeight: 400 }}
      >
        <div className="position-relative h-100">
          <img
            className="img-fluid position-absolute w-100 h-100"
            src="https://cdn.pixabay.com/photo/2021/08/04/13/06/software-developer-6521720_640.jpg"
            alt=""
            style={{ objectFit: "cover" }}
          />
        </div>
      </div>
      <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
      <div className='d-flex flex-start align-items-center justify-content-start mb-4 mt-2'>
          
                    <h6 className="sub_heading text-start">Syllabus</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
        <h1 className="mb-4 Heading">Embedded Software Development Course</h1>
        <p className="mb-4" style={{color:"#001f3f"}}>
        Learn to program microcontrollers, optimize real-time systems, and develop robust embedded solutions for various applications.
        </p>
       
     
        <a className="btn  py-3 px-5 mt-2 text-white" href="#form" style={{backgroundColor:"yellowgreen"}}>
        Join Now
        </a>
      </div>
    </div>
  </div>
</div>

<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading sm_txt"style={{whiteSpace:"nowrap"}}>6-Months</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>

      <div className="card_container">
        {syllabusData.map((module, index) => (
          <div key={index} className="card bgimg">
            <h3 className="card_title">{module.text}</h3>
            <ul className="card_sublist">
              {module.subDescription.map((subItem, subIndex) => (
                <li key={subIndex} className="card_subitem">
                  {subItem}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">45-Days</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
    <div className="container-fluid card_container px-3">
  <div className="row">
    {syllabusData_one.map((module, index) => (
      <div key={index} className="col-lg-4 col-md-6 mb-4">
        <div className="card bgimg h-100 shadow-sm">
          <div className="card-body">
            <h3 className="card_title">{module.title}</h3>
            <h6 style={{color:"#c63b36"}}>{module.note}</h6>
            <ul className="card_sublist" style={{listStyleType:"disc"}}>
              {module.description.map((item, subIndex) => (
                <li key={subIndex}>
                  {typeof item === 'string' ? (
                    item
                  ) : (
                    <>
                      {item.text}
                      <ul className=" ms-3" style={{listStyleType:"circle"}}>
                        {item.subDescription.map((subItem, subDescIndex) => (
                          <li key={subDescIndex}>{subItem}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    ))}
  </div>
</div>


<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">FAQs</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
<FAQs/>
      <div class="container-xxl mt-5 py-3" >
        <div class="container">
         
<div className="container-xxl mt-5">
  <div className="container">
    <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
    <div className='d-flex flex-row align-items-center justify-content-center mb-5'>
            <img 
                    className='pe-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                    <h6 className="sub_heading p">Contact</h6>
                    <img 
                    className='ps-3'
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACLklEQVR4nO2XT2sTQRTAn/SgYO3uzG6Tk1RRqwgW/x68SE+56ofQq36EaJP31lovfo2AINLsmy3FXPXspSfBgijGahGE3iIvkmQqDenuBsvg/OBd3mF23uzb2d8D8Hg8Ho/H85+jGR8pQy9jbl4H1wiyxlltqNcPph/OFVHN1k4qxk+jIvBbmOISuIRqP70iGx8WYeirTvEyuESQNa9qpp1BEYrpS2TwUqlFK5tYVUzvNNP7uE2Lk/I6rc8pgx1t8HvB2LPegrTTx2q2VilcgDL4YHQi+HhSPjJ4b98GphCKk/vlbgimbW2wa98O4/KzKc4rQ1tTK4BpJ+DkDJSi1zsGrdbMofNSYKceBuuJyhPRRvOmHIjVPrtRSrfABZRpnNZMH4ZtY+hXmCV3wAUWOvUTdtvJ5iNOlsEV4o2VC6O+xz2dUQ1cQxt6phjfOrl5T17k3hf11UwPwTXiLLkhyjv46ML1xgK4Qpjikm2MosCiwuACcZsWlcHP9uARpMk1cIF5Q+f/Gjh25bcPLlDZxOofabMlS5S3mC4rpjfRq9VTg/UjXrkoSi7/AHnWpHxubG2eVkSc3B2uz/TkIG0el8+NqKw9JZV2e0Nbs6+fx/tuNYNdGVxsbR6XL4QorfS91UJd+Qby6rIo9oEPaLVm+mp+2HwRFNNtZfCndQttlx80/jERJ8uiunY7QPriOLiEzqhmD95zaeMcuIbOqNZXX0OrR70Xj8fj8Xg8cMT8BtFVe5J3SM2jAAAAAElFTkSuQmCC" alt="sorting-arrows-horizontal"/>
                  </div>
     
   
    </div>
    </div>
    </div>
            <div className='mt-4'>
            <ApplyForm/>
            </div>
        
        </div>
    </div>
    <div className='container mt-5 mb-5'>
        <div className='row'>
            <div className='col-12'>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.4728947145964!2d75.58318561066835!3d31.345927155633603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391a5bde4b978ac5%3A0xe6b30ccf89446f33!2sDigitalMonk!5e0!3m2!1sen!2sin!4v1737619055819!5m2!1sen!2sin"
                style={{ border: 0, width: "100%", height: "350px" }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
        </div>
    </div>
    </>
  );
}

